import { Flow } from '../../services/viva/constants';

export type CartEmptyFlowText = {
  title: string;
  description: string;
  buyTicketsLink: string;
  learnMoreLink: string;
};

export type CartTranslations = {
  title: string;
  emptyCart: {
    byFlow: {
      [key in Flow]?: CartEmptyFlowText;
    };
    headline: string;
    buyTicketsButtonText: string;
    learnMoreButtonText: string;
    viewAllButtonText: string;
  };
  summary: {
    title: string;
    total: string;
    fees: string;
    promoCode: string;
    promoCodePlaceholder: string;
    promoCodeLabel: string;
  };
  sessionTimeoutHeader: string;
  sessionTimeoutText: string;
  sessionTimeoutButtonText: string;
};

const cartTranslations: CartTranslations = {
  title: 'Your Cart',
  emptyCart: {
    headline: 'There are no items in your cart. Check out these attractions.',
    buyTicketsButtonText: 'Buy Tickets',
    learnMoreButtonText: 'Learn More',
    viewAllButtonText: 'View All Attractions',
    byFlow: {
      [Flow.TOR_GA]: {
        title: 'General Admission',
        description:
          'See the best NYC view from 70 floors up at our indoor and outdoor observation decks.',
        buyTicketsLink: '#top-of-the-rock-observation-deck',
        learnMoreLink: '/attractions/top-of-the-rock-observation-deck/',
      },
      [Flow.ALL_IN_PASS]: {
        title: 'All In Pass',
        description:
          'Enjoy Top of the Rock’s most popular attractions, SKYLIFT and The Beam Experience, and save up to $20 with this combo ticket - an online advance purchase exclusive',
        buyTicketsLink: '#top-of-the-rock-observation-deck',
        learnMoreLink: '/attractions/top-of-the-rock-observation-deck/',
      },
      [Flow.THE_BEAM_PASS]: {
        title: 'The Beam Pass',
        description:
          "Access three levels of indoor and outdoor observation decks with the best unobstructed views of NYC's famous landmarks. Then, follow in the fearless footsteps of the 1920s ironworkers by buckling up for an ascent above the deck on The Beam Experience to recreate the iconic Lunch Atop a Skyscraper photo while taking in the astonishing views of Central Park and beyond.",
        buyTicketsLink: '#top-of-the-rock-observation-deck',
        learnMoreLink: '/the-beam/',
      },
      [Flow.RINK]: {
        title: 'The Rink',
        description:
          'Skate at NYC’s most iconic Rink. General admission tickets include a 60-minute skate session.',
        buyTicketsLink: '#the-rink',
        learnMoreLink: '/attractions/the-rink-at-rockefeller-center/',
      },
      [Flow.RC_TOUR]: {
        title: 'Rockefeller Center Tour',
        description:
          "On your live, guided tour an expert historian will introduce you to Rockefeller Center's most significant buildings, gardens, and spaces. Some highlights are stops at the Associated Press Building, where the TODAY Show is filmed.",
        buyTicketsLink: '#rockefeller-center-tour',
        learnMoreLink: '#tbd',
      },
      [Flow.TOR_EXPRESS]: {
        title: 'Top of the Rock Express',
        description:
          'See the best NYC view from 70 floors up at our indoor and outdoor observation decks.',
        buyTicketsLink: '#top-of-the-rock-observation-deck',
        learnMoreLink: '/attractions/top-of-the-rock-observation-deck/',
      },
      [Flow.TOR_VIP]: {
        title: 'VIP Pass',
        description:
          'Skip the line and go on a guided, exclusive tour of the top of 30 Rockefeller Plaza, including Top of the Rock Observation Deck and Rainbow Room (based on availability.)',
        buyTicketsLink: '#top-of-the-rock-observation-deck',
        learnMoreLink: '/attractions/top-of-the-rock-observation-deck/',
      },
      [Flow.RINK_VIP]: {
        title: 'Premium Skate',
        description: 'Premium Skate',
        buyTicketsLink: '#the-rink',
        learnMoreLink: '/attractions/the-rink/',
      },
      [Flow.RINK_MEMBERSHIP]: {
        title: 'Rink Membership',
        description: 'Rink Membership',
        buyTicketsLink: '#the-rink',
        learnMoreLink: '/attractions/the-rink/',
      },
      [Flow.CHALETS]: {
        title: 'Rink Chalets',
        description: 'Rink Chalets',
        buyTicketsLink: '#the-rink',
        learnMoreLink: '/attractions/the-rink/',
      },
      [Flow.RC_TOUR_KIDS_AND_FAMILY]: {
        title: 'Rockefeller Center Tour Jr.',
        description: 'Rockefeller Center Tour Jr.',
        buyTicketsLink: '#rockefeller-center-tour',
        learnMoreLink: '/attractions/rockefeller-center-tour/',
      },
      [Flow.RC_ROCK_PASS]: {
        title: 'Rock Pass',
        description: 'Rock Pass',
        buyTicketsLink: '#top-of-the-rock-observation-deck',
        learnMoreLink: '/attractions/top-of-the-rock-observation-deck/',
      },
      [Flow.TOR_VIP_ROCKSTAR]: {
        title: 'VIP Rock Pass',
        description: 'VIP Rock Pass',
        buyTicketsLink: '#rockefeller-center-tour/',
        learnMoreLink: '/attractions/rockefeller-center-tour/',
      },
      [Flow.TREE_PHOTO]: {
        title: 'Tree Photo',
        description: 'Tree Photo',
        buyTicketsLink: '#tree-photo',
        learnMoreLink: '/attractions/tree-photo/',
      },
    },
  },
  summary: {
    title: 'Order Summary',
    total: 'Estimated Total',
    fees: 'Processing Fees',
    promoCode: 'Promo Code',
    promoCodePlaceholder: 'Enter promo code',
    promoCodeLabel: 'Have a promo code?',
  },
  sessionTimeoutHeader: 'Session expired.',
  sessionTimeoutText:
    'The timer on the cart holding your tickets has expired and your tickets have been released. Please revisit the ticketing page to make a new selection.',
  sessionTimeoutButtonText: 'View Tickets',
};

export default cartTranslations;
